import { useEffect } from "react";
import { Textfit } from "react-textfit";
import { Question } from "src/pods/pairshare/types";
import logEvent from "src/utils/logEvent";
import styles from "./PairShareResult.module.css";

type Props = {
  question?: Question;
};

export default function PairShareResult({ question }: Props) {
  useEffect(() => {
    logEvent({ eventName: "pairshare.result.open" });
    return () => {
      logEvent({ eventName: "pairshare.result.close" });
    };
  }, []);

  const text = question?.text ?? "";

  return (
    <div className={styles.container}>
      <div className={styles.background}>
        <Textfit className={styles.textfit} max={64}>
          {text.split("\n").map((line, index) => (
            <div key={index} className={styles.line}>
              {line}
            </div>
          ))}
        </Textfit>
      </div>
    </div>
  );
}
